import { WS_CALL_SIDEBAR_ACTIONS } from '../constants/actionsConstants';

const initialState = {
  clients: [],
  loading: true,
  searchText: '',
  currentStep: 'CLIENT_LIST',
  selectedClient: null,
  fetchError: false
};

/**
 * Reducer for managing the state of the WS Call Sidebar.
 *
 * @param {Object} state - The current state of the WS Call Sidebar.
 * @param {Object} action - The action being dispatched.
 * @returns {Object} The new state of the WS Call Sidebar.
 */
const wsCallSidebarReducer = (state = initialState, action) => {
  switch (action.type) {
    case WS_CALL_SIDEBAR_ACTIONS.SET_CLIENTS:
      return {
        ...state,
        clients: action.payload,
        fetchError: false
      };
    case WS_CALL_SIDEBAR_ACTIONS.SET_LOADING:
      return {
        ...state,
        loading: action.payload
      };
    case WS_CALL_SIDEBAR_ACTIONS.SET_SEARCH_TEXT:
      return {
        ...state,
        searchText: action.payload
      };
    case WS_CALL_SIDEBAR_ACTIONS.SET_CURRENT_STEP:
      return {
        ...state,
        currentStep: action.payload
      };
    case WS_CALL_SIDEBAR_ACTIONS.SET_SELECTED_CLIENT:
      return {
        ...state,
        selectedClient: action.payload
      };
    case WS_CALL_SIDEBAR_ACTIONS.SET_FETCH_ERROR:
      return {
        ...state,
        fetchError: Boolean(action.payload)
      };
    case WS_CALL_SIDEBAR_ACTIONS.RESET_STATE:
      return initialState;
    default:
      return state;
  }
};

export default wsCallSidebarReducer;
